<rotec-modal-v2 [width]="width" [darkMode]="true">
  <ng-container ngProjectAs="modal-main">
    <div class="delete-rotor-type__title">
      <p>{{ 'Deleting VALUE' | translate: { value: title } }}</p>
    </div>

    <div class="delete-rotor-type__content" translate>
      <div class="main-info">
        <p translate>
          Do you really want to delete the rotor
          {{ modalRef.data.rotorTypes.length > 1 ? 'types' : 'type' }} from the cloud database?
        </p>
        <p translate>Deleted data will be lost</p>
      </div>

      @if (syncTitle) {
        <div class="additional-info">
          <p translate>
            Do you also want to delete the rotor
            {{ syncedRotorTypes.length > 1 ? 'types' : 'type' }} on the assigned machines?
          </p>
          <div class="checkbox">
            <rotec-checkbox-v2
              [status]="isDeleteOnMachine ? 'checked' : 'unchecked'"
              [darkMode]="true"
              (statusChange)="toggleCheckbox()"
            ></rotec-checkbox-v2>
            <p>{{ 'Delete VALUE from all machines' | translate: { value: syncTitle } }}</p>
          </div>
        </div>
      }
    </div>
  </ng-container>

  <ng-container ngProjectAs="modal-buttons">
    <button rotec-button-secondary dark (click)="close()">
      {{ 'Cancel' | translate }}
    </button>
    <button rotec-button-warning (click)="apply()">
      {{ 'COMMON_Delete' | translate }}
    </button>
  </ng-container>
</rotec-modal-v2>
